/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dashboard[_ngcontent-%COMP%]{height:100%;display:grid;grid-template-rows:80px 44px 1fr}.dashboard__logo-container[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.dashboard__logo[_ngcontent-%COMP%]{display:block;max-height:64px}.dashboard__header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:flex-start}.dashboard__results[_ngcontent-%COMP%]{overflow:hidden}"];
export { styles as styles };
